import React from "react";

const ExperienceCard = ({ value }) => {
  return (
    <div className="col-md-6">
      <div className="card shadow-lg p-3 mb-5 bg-white rounded">        
        <div className="card-body">
          <h5 className="card-title">{value.name} - {value.company}</h5>
          <p className="card-text">{value.description} </p>         
          <hr />
          <Language value={value.competences}></Language>
          <p className="card-text">            
            <small className="text-muted">{value.date}</small>
          </p>
        </div>
      </div>
    </div>
  );
};

const Language = ({ value }) => {
  return (
    <div className="pb-3">
      Competences:{" "}
      {value.map((language) => (
        <span key={language} className="badge bg-secondary text-white me-1 mb-1">{language}</span>
      ))}
    </div>
  );
};

export default ExperienceCard;
